import type { GossipTimelineItem } from "@/mocks/events";
import { stageColor } from "@/lib/format";

export default function EventTimeline({ items }: { items: GossipTimelineItem[] }) {
  return (
    <section id="timeline" className="scroll-mt-24">
      <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">事件时间线</h2>
      <p className="mt-2 text-sm text-foreground-600">
        按发生、发酵、回应、后续四段排列，从上往下读一遍就能掌握完整脉络。
      </p>

      <ol className="mt-6 relative flex flex-col gap-5 border-l-2 border-dashed border-background-300 pl-6">
        {items.map((item) => (
          <li key={`${item.time}-${item.title}`} className="relative rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
            <span className="absolute -left-[35px] top-5 flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 ring-4 ring-background-50">
              <i className="ri-circle-fill text-[6px] text-background-50" />
            </span>
            <div className="flex flex-wrap items-center gap-2">
              <span className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold ${stageColor(item.stage)}`}>
                {item.stage}
              </span>
              <time className="text-xs text-foreground-500">{item.time}</time>
            </div>
            <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-900">{item.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}